export default __webpack_public_path__ + "assets/images/1.ddd5a9.avif";